import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterModel } from 'src/Models/filterModel';

@Injectable({
  providedIn: 'root'
})
export class RmdupdatesService {

  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }
  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  GetUpdatesFilterByPage(TokenKey: string, filterModel: FilterModel): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDUpdatesFilter';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ActiveInactiveRMDUpdates(TokenKey: string, updateId: string, isactive: string): Observable<any[]> {
    const data = '/' + updateId;
    const fullAPIPath = this.AppUrl + 'api/RMDUpdates/ActiveInActiveUpdate' + data + '/' + isactive;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetRMDUpdatesFindByCarrierID(TokenKey: string, carrierID: number): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDUpdatesFindByCarrierID/' + carrierID;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }

  GetScheduleLogFilterByPage(TokenKey: string, filterModel: FilterModel): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetScheduleLogFilterByPage';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetScheduleLogHistory(TokenKey: string, filterModel: FilterModel) {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + `api/RMDUpdates/GetScheduleLogHistory`;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
  GetUpdateHistoryByCarrierID(TokenKey: string, carrierId: number) {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + `api/RMDUpdates/GetUpdateHistoryByCarrierID/${carrierId}`;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUpdatesFilterByPageV2(TokenKey: string, filterModel: FilterModel): Observable<any> {
    this.setAPIUrl();
    const fullAPIPath = this.AppUrl + 'api/RMDUpdates/V2/GetRMDUpdatesFilter';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }
}
